class WorkoutSlider extends HTMLElement {
  constructor() {
    super();
    this.emblaNode = this.querySelector('.embla');
    this.slideContainer = this.emblaNode.querySelector('.embla__container');
    this.slidesHolder = document.createElement('div');
    this.slidesHolder.style.display = 'none';
    this.emblaNode.appendChild(this.slidesHolder);
    this.prevButton = this.querySelector('.prev');
    this.nextButton = this.querySelector('.next');
    this.categoryButtons = this.querySelectorAll('.category-button');
    this.slides = this.querySelectorAll('.embla__slide');
    this.options = {
      loop: true,
      align: 'start',
      slidesToScroll: 1,
    };
    this.setupCarousel = this.setupCarousel.bind(this);
  }

  setupCarousel() {
    // Only select visible slides for Embla
    const visibleSlides = Array.from(this.slides).filter((slide) => slide.style.display !== 'none');

    // Create a new container with only visible slides
    const container = this.emblaNode.querySelector('.embla__container');
    container.innerHTML = '';
    visibleSlides.forEach((slide) => container.appendChild(slide));

    this.embla = EmblaCarousel(this.emblaNode, this.options);

    // Add button listeners with scroll by index
    this.prevButton.onclick = () => {
      this.embla.scrollPrev();
    };
    this.nextButton.onclick = () => {
      this.embla.scrollNext();
    };
  }

  connectedCallback() {
    this.setupCarousel();

    // Add category filtering
    this.categoryButtons.forEach((button) => {
      button.addEventListener('click', () => this.filterCategory(button));
    });

    // Initialize with first category
    this.filterCategory(this.categoryButtons[0]);
  }

  reinitializeCarousel() {
    // Destroy current instance before modifying slides
    if (this.embla) {
      this.embla.destroy();
    }

    // Reinitialize the carousel
    requestAnimationFrame(() => {
      this.embla = EmblaCarousel(this.emblaNode, this.options);
    });
  }

  filterCategory(selectedButton) {
    const selectedCategory = selectedButton.dataset.category;

    // Update active button state
    this.categoryButtons.forEach((button) => {
      button.classList.remove('active');
    });
    selectedButton.classList.add('active');

    let visibleSlides = 0;

    // Move all slides to the holder first
    Array.from(this.slides).forEach((slide) => {
      this.slidesHolder.appendChild(slide);
    });

    // Move matching slides to the container
    Array.from(this.slides).forEach((slide) => {
      const slideCategories = (slide.dataset.categories || '').split(',');

      if (selectedCategory === 'all' || slideCategories.includes(selectedCategory)) {
        this.slideContainer.appendChild(slide);
        visibleSlides++;
      }
    });

    // Show/hide navigation buttons based on screen size and visible slides
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const showNav = isDesktop ? visibleSlides > 4 : visibleSlides > 1;
    this.prevButton.style.display = showNav ? '' : 'none';
    this.nextButton.style.display = showNav ? '' : 'none';

    this.reinitializeCarousel();
  }
}

customElements.define('workout-slider', WorkoutSlider);
